<template>
  <div :class="componentClasses">
    <i :class="icon" />
  </div>
</template>

<script setup>
import { computed } from 'vue';

const props = defineProps({
  icon: {
    type: String,
    default: 'fas fa-chevron-down',
  },
  size: {
    type: String,
  },
  resize: {
    type: String,
  },
});

const componentClasses = computed(() => [
  'stk-icon',
  props.size && !props.resize ? `stk-size-${props.size}` : '',
  props.resize ? `stk-resize-${props.resize}` : '',
]);
</script>

<style>
.stk-icon {
  align-items: center;
  color: inherit;
  display: inline-flex;
  flex-shrink: 0;
  height: var(--stk-icon-dimensions);
  justify-content: center;
  transition-duration: var(--stk-transition-duration);
  transition-property: background-color, color;
  vertical-align: top;
  width: var(--stk-icon-dimensions);
}
</style>
